import Vue    from 'vue'
import moment from 'moment'

Vue.filter('data_ora', function(value) {
    if (value) {
        return moment(String(value)).format('HH:mm')
    }
})
Vue.filter('data_slash', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
})
Vue.filter('data_underscore', function(value) {
    if (value) {
        return moment(String(value)).format('DD_MM_YYYY')
    }
})
Vue.filter('DD/MM', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM')
    }
})
Vue.filter('data_full', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
    }
})
Vue.filter('formatDateTimeToIT', function(value) {
    if (!value) return '';

    const d = new Date(value);

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // mesi partono da 0
    const year = d.getFullYear();

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
});